import { Model, ModelAttributes, model, modelConfig, reference } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import AccountUser from "./AccountUser";
import FundingOutreachCommunication from "./FundingOutreachCommunication";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    account_user_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    funding_outreach_communication_id: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    read_at: {
      type: "datetime",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {
    account: reference(() => Account as any, "account_id"),
    account_user: reference(() => AccountUser as any, "account_user_id"),
    funding_outreach_communication: reference(
      () => FundingOutreachCommunication as any,
      "funding_outreach_communication_id",
    ),
  },
);

interface FundingOutreachCommunicationRead extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_outreach_communication_reads", config)
class FundingOutreachCommunicationRead extends Model<typeof config> {}

export default FundingOutreachCommunicationRead;
